import React from 'react';
import { FieldValidator } from 'final-form';
import { RenderFileUpload } from 'forms';
import { Validator } from 'forms/validators/types';
import { Field } from 'react-final-form';

interface Props {
    name: string;
    validate?: FieldValidator<Validator>;
    nullOnUnmount?: boolean;
    label?: string;
    accept?: string;
}

export default function FileUploadField(props: Props): React.ReactElement {
    const { name, validate, nullOnUnmount, label, accept = '.csv' } = props;

    return (
        <Field
            component={RenderFileUpload as any}
            subscription={{
                value: true,
                touched: true,
                error: true
            }}
            type="file"
            accept={accept}
            name={name}
            label={label}
            placeholder="Select file to upload"
            fluid
            search
            selection
            clearable
            selectOnBlur={false}
            validate={validate}
            nullOnUnmount={nullOnUnmount}
        />
    );
}
